<template>
  <div>
    <b-card
      header="Enforce state from ext id"
      bg-variant="light"
    >
      <b-form @submit.prevent="enforce">
        <b-form-group
          label="Source ext id"
          label-for="source-ext-id"
        >
          <b-form-input
            id="source-ext-id"
            v-model="sourceExtId"
            required
          >
          </b-form-input>
        </b-form-group>
        <b-button type="submit" variant="danger">Enforce</b-button>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import { parseExtId } from '../model/ext_id.js';

export default {
  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      sourceExtId: '',
    };
  },

  methods: {
    enforce() {
      notifier.deleteSenderNotifications(this);

      const [sourceExtId, err] = parseExtId(this.sourceExtId);
      if(err !== null) {
        notifier.showError(err, {sender: this});
        return;
      }
      if(sourceExtId === null) {
        notifier.showError(new Error('sourceExtId === null'), {sender: this});
        return;
      }

      const data = new FormData();
      data.set('source_ext_id', sourceExtId);

      this.sourceExtId = '';

      HTTP.post('/player/' + this.playerId + '/enforce_state', data)
      .then(() => {
        notifier.showSuccess('State enforced.');
      })
      .catch(err => {
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
